export const labelStyle = {
  marginTop: '0',
  marginBottom: '10px',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '0.9rem',
  fontWeight: 300,
  lineHeight: '1.2rem',
};
